import { Paper } from '@mui/material';
import Tooltip from './BinTooltip';
import React from 'react';
import styles from './box-layout.styles';
import { Component } from 'react';
import { withStyles } from '@mui/styles';
import './index.css';
import { withTranslation } from 'react-i18next';
import LockIcon from '@mui/icons-material/Lock';
import {
    getColumnIdFromBinId as resolveColumnIdFromBinId,
    isRestrictedByColumnMapping as isColumnRestrictedByMapping,
    isBinRestrictedForUser,
    getColumnRestrictionHighlightStyle,
    shouldShowRestrictionLock,
} from './columnRestriction';

let nums = Array.from(Array(3).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C'];
let deactivatedBin = [];
let IsSaved;
let BinIds = [];

export class Main22Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        const { BinStatus } = this.props;
        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
            BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    getColumnIdFromBinId = (binId) => resolveColumnIdFromBinId(binId);

    isRestrictedByColumnMapping = (binId) =>
        isColumnRestrictedByMapping(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    isRestricted = (groupTypeId, binId) =>
        isBinRestrictedForUser({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId: groupTypeId,
        });

    getColumnRestrictionStyle = (binId) =>
        getColumnRestrictionHighlightStyle(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    renderBinLabel = (binId, label, occupiedGroupTypeId = null) => [
        shouldShowRestrictionLock({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId,
        }) ? <LockIcon key={`${binId}-lock`} fontSize='12px' /> : null,
        <span key={`${binId}-label`}>&nbsp;{label}</span>,
    ];

    openbin = (binId, status, pm_id) => {
        // Check if bin is restricted by column mapping
        if (this.isRestrictedByColumnMapping(binId)) {
            return; // Don't allow opening if restricted by column mapping
        }
        
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                let items = document.getElementById(binId);
                items.style.background = '#f87171'; // deavtivated
                items.style.color = '#ffffff'
            }
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            // Handle deactivated bins without status - allow activation
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                this.props.getPrescriptionDetails(binId, pm_id);
                let items = document.getElementById(binId);
                if (items) {
                    items.style.background = '#f87171'; // deavtivated
                    items.style.color = '#ffffff'
                }
            } else {
                BinIds.map((item) => {
                    this.checkIsSaved(item);
                    if (this.props.deactivatedBins.includes(item)) {
                        let items = document.getElementById(item);
                        items.style.background = '#f87171'; // deavtivated
                        items.style.color = '#ffffff'
                    } else {
                        if (item !== binId && IsSaved === false) {
                            let items = document.getElementById(item);
                            items.style.background = '#f8fafc'; // available
                        }
                    }
                    return true
                })
                BinIds = [];
                BinIds.push(binId);
                if (BinIds.length > 0) {
                    this.props.Selectedbin(binId, this.props.box_position);
                    var items = document.getElementById(binId);
                    items.style.background = '#fbbf24'; // assigned
                    if (this.props.deactivatedBins.includes(binId)) {
                        items.style.color = '#000000';
                    }
                }
            }
        }
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }
        const { classes, BinStatus, deactivatedBins, t, isViewPermissionAllowed, PatientID, ADAData} = this.props;
        return (
            <div key={this.props.prefix} className={classes.unitFrame}>
                <div
                    className={classes.m22Grid}
                    style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                >
                    <div className={classes.m22DisplayPanel} aria-hidden="true">
                        <div className={classes.kioskDisplayInner}>
                            <span>SCREEN</span>
                        </div>
                    </div>
                    {nums1.map((n1) => {
                        let doorInx = n1 + 1;
                        const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                            return (
                                item &&
                                item.patient_id === PatientID &&
                                item.ada_compitible === true &&
                                ![7, 8, 9].includes(doorInx)
                            );
                        });
                        return nums.map((n) => {
                                    if ((elem[n] === 'A' || elem[n] === 'B') && (n1 >= 0 && n1 <= 6)) {
                                        return null;
                                    }
                                    if (elem[n] === 'A' || elem[n] === 'B' || elem[n] === 'C') {
                                            if (BinStatus && BinStatus.length && BinStatus.length > 0) {
                                                let BinKey = elem[n] + (n1 + 1)
                                                for (var i = 0; i < BinStatus.length; i++) {
                                                    let pm_id = BinStatus[i].id;
                                                    let occupiedGroupTypeId = BinStatus[i].group_type_id;
                                                    let isMarketplaceBin = !!(BinStatus[i] && BinStatus[i].is_marketplace_lock); let isLockedBin = BinStatus[i].is_locked
                                                    if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin(elem[n] + '' + (n1 + 1), 'Stocked')}
                                                                        key={elem[n] + ' ' + (n1 + 1)}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={isMarketplaceBin ? "Shop" : t("Global.Prescriptions.Status.Stocked")}>
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin((elem[n] + '' + (n1 + 1)), 'Stocked', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={isMarketplaceBin ? classes.gridMarketplaceBin : isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin(elem[n] + '' + (n1 + 1), 'Assigned')}
                                                                        key={elem[n] + ' ' + (n1 + 1)}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Assigned")}>
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin((elem[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={isMarketplaceBin ? classes.gridMarketplaceBin : isLockedBin ? classes.gridPurpleBin : classes.gridBlueback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin(elem[n] + '' + (n1 + 1), 'Hold')}
                                                                        key={elem[n] + ' ' + (n1 + 1)}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Hold")}>
                                                                    <div
                                                                        className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                        style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() =>this.openbin((elem[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={isMarketplaceBin ? classes.gridMarketplaceBin : isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback}
                                                                            style={this.getColumnRestrictionStyle(BinKey)}>
                                                                            {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                                        </Paper>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                }
                                                if (deactivatedBins && deactivatedBins.length && deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                            <div
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                    style={this.getColumnRestrictionStyle(BinKey)}>
                                                                    {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                            <div
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}
                                                                    style={this.getColumnRestrictionStyle(BinKey)}>
                                                                    {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                }
                                            } else {
                                                if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                            <div
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}
                                                                    style={this.getColumnRestrictionStyle(elem[n] + '' + (n1 + 1))}>
                                                                    {this.renderBinLabel(elem[n] + '' + (n1 + 1), `${elem[n]} ${n1 + 1}`)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                            <div
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  padding: 0, pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}
                                                                    style={this.getColumnRestrictionStyle(elem[n] + '' + (n1 + 1))}>
                                                                    {this.renderBinLabel(elem[n] + '' + (n1 + 1), `${elem[n]} ${n1 + 1}`)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                }
                                            }
                                        }
                                    return null;
                                });
                    })}
                </div>
            </div>
        );
    }
};

export default withStyles(styles)(withTranslation()(Main22Layout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Main22-layout.js